function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/jsx-no-constructed-context-values */
/* eslint-disable react/jsx-props-no-spreading */
import PropTypes from 'prop-types';
import React, { useReducer } from 'react';
import ReactDOM from 'react-dom';
import produce from 'immer';
import Button from '@components/common/form/Button';
import { Card } from '@components/admin/cms/Card';
import './Alert.scss';
import { assign } from '../../../lib/util/assign';
var AlertContext = /*#__PURE__*/React.createContext();
export var useAlertContext = () => React.useContext(AlertContext);
function reducer(state, action) {
  switch (action.type) {
    case 'close':
      return _objectSpread(_objectSpread({}, state), {}, {
        showing: false,
        closing: false
      });
    case 'closing':
      return _objectSpread(_objectSpread({}, state), {}, {
        showing: true,
        closing: true
      });
    case 'open':
      return _objectSpread(_objectSpread({}, state), {}, {
        showing: true,
        closing: false
      });
    default:
      throw new Error();
  }
}
var alertReducer = produce((draff, action) => {
  switch (action.type) {
    case 'open':
      // eslint-disable-next-line no-param-reassign
      draff = _objectSpread({}, action.payload);
      return draff;
    case 'remove':
      return {};
    case 'update':
      assign(draff, action.payload);
      return draff;
    default:
      throw new Error();
  }
});
function Alert(_ref) {
  var {
    children
  } = _ref;
  var [alert, dispatchAlert] = useReducer(alertReducer, {});
  var [state, dispatch] = useReducer(reducer, {
    showing: false,
    closing: false
  });
  var openAlert = _ref2 => {
    var {
      heading,
      content,
      primaryAction,
      secondaryAction
    } = _ref2;
    dispatchAlert({
      type: 'open',
      payload: {
        heading,
        content,
        primaryAction,
        secondaryAction
      }
    });
    dispatch({
      type: 'open'
    });
  };
  return /*#__PURE__*/React.createElement(AlertContext.Provider, {
    value: {
      dispatchAlert,
      openAlert,
      closeAlert: () => dispatch({
        type: 'closing'
      })
    }
  }, children, state.showing === true && /*#__PURE__*/ReactDOM.createPortal(/*#__PURE__*/React.createElement("div", {
    className: state.closing === false ? 'modal-overlay fadeIn' : 'modal-overlay fadeOut',
    onAnimationEnd: () => {
      if (state.closing) {
        dispatch({
          type: 'close'
        });
        dispatchAlert({
          type: 'remove'
        });
      }
    }
  }, /*#__PURE__*/React.createElement("div", {
    key: state.key,
    className: "modal-wrapper flex self-center justify-center",
    "aria-modal": true,
    "aria-hidden": true,
    tabIndex: -1,
    role: "dialog"
  }, /*#__PURE__*/React.createElement("div", {
    className: "modal"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "modal-close-button text-icon",
    onClick: () => dispatch({
      type: 'closing'
    })
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "2rem",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement(Card, {
    title: alert.heading
  }, /*#__PURE__*/React.createElement(Card.Session, null, alert.content), (alert.primaryAction !== undefined || alert.secondaryAction !== undefined) && /*#__PURE__*/React.createElement(Card.Session, null, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-end space-x-4 gap-4"
  }, alert.primaryAction && /*#__PURE__*/React.createElement(Button, alert.primaryAction), alert.secondaryAction && /*#__PURE__*/React.createElement(Button, alert.secondaryAction))))))), document.body));
}
Alert.propTypes = {
  children: PropTypes.node.isRequired
};
export { Alert };